import { buildUrl, handleResponse } from "./auth";

const buildQuery = (params = {}) => {
  const parts = Object.entries(params)
    .filter(([, value]) => value !== undefined && value !== null && value !== "")
    .map(
      ([key, value]) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(
          value instanceof Date ? value.toISOString() : value
        )}`
    );
  return parts.length ? `?${parts.join("&")}` : "";
};

export const getAdminPayments = (params) =>
  fetch(buildUrl(`/api/admin/payments${buildQuery(params)}`), {
    credentials: "include",
  }).then(handleResponse);

const adminPaymentsApi = { getAdminPayments };

export default adminPaymentsApi;
